import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { getConfectioneryDetail } from "../../utils/confectioneryManager";
import { useCheckoutStore } from "../../store/useCheckoutStore";

const Resume = ({ recipe, showTitle = true, productApi }) => {
  const [resume, setResume] = useState([]);
  const { confectioneries_api } = useCheckoutStore();

  useEffect(() => {
    const elements = [];
    recipe.forEach((item) => {
      if (!productApi) return;
      if (item.Tipo === "P") {
        const itemApi = getConfectioneryDetail(
          item.Codigo,
          confectioneries_api
        );
        elements.push(
          <Box key={item.Codigo} sx={{ mb: 0, lineHeight: "1em" }}>
            <Typography
              variant="caption"
              component="span"
              sx={{ fontWeight: "bold", fontFamily: "var(--bold)" }}
            >
              {itemApi?.category_name.toUpperCase()}
              {item.Cantidad > 1 ? "S" : ""}:
            </Typography>{" "}
            <Typography variant="caption" component="span">
              {itemApi?.name}
            </Typography>
          </Box>
        );
      } else {
        let subItemApi = "";
        const recipeNames = item?.Receta.map((subItem, index) => {
          if (!productApi) return "";
          subItemApi = getConfectioneryDetail(
            subItem.Codigo,
            confectioneries_api
          );
          return `${index > 0 ? "; " : ""}${subItemApi?.name}`;
        }).join("");
        elements.push(
          <Box key={item.Codigo} sx={{ mb: 0, lineHeight: "1em" }}>
            <Typography
              variant="caption"
              component="span"
              sx={{ fontWeight: "bold", fontFamily: "var(--bold)" }}
            >
              {subItemApi?.category_name.toUpperCase()}
              {item.Cantidad > 1 ? "S" : ""}:
            </Typography>{" "}
            <Typography variant="caption" component="span">
              {recipeNames}
            </Typography>
          </Box>
        );
      }
    });
    setResume(elements);
  }, [recipe, productApi, confectioneries_api]);

  return (
    <Box
      sx={{
        p: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "0px",
      }}
    >
      {showTitle && (
        <Typography sx={{ fontFamily: "var(--bold)" }} variant="body1">
          Resumen:
        </Typography>
      )}
      {resume}
    </Box>
  );
};

Resume.propTypes = {
  showTitle: PropTypes.bool,
  recipe: PropTypes.array,
  productApi: PropTypes.object,
};

export default Resume;
